import Shape360 from '../../pages/shape-360/Shape360'

import PrefixEnum from '../prefixes'

export default Object.freeze([
    { path: PrefixEnum.SHAPE_360, component: Shape360 },
])
